module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-6@3x.ver2_0_2.jpg?9fdb82a6";